import { BROADCAST_UPDATE_OVERLAY_STATE } from 'actions/Types';
import { OVERLAY_ADD } from 'store/eventConstants';
import { mapSignedUrlsToSources } from 'actions/utils';
import { withCurrentParams } from 'actions/utils';

/**
 * updateOverlayUploadStatus updates the signed url fetched using s3 proxy once upload is successful.
 * @param {string} payload contains Team Id, Event Id, Broadcast Id and updated Overlay
 */
function updateOverlayUploadStatus(overlay) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, _, socket) => {
      const action = {
        type: BROADCAST_UPDATE_OVERLAY_STATE,
        request: async apiClient => {
          const mappedOverlay = await mapSignedUrlsToSources(
            [overlay],
            apiClient,
            teamId,
            eventId,
            true
          );
          const updatedOverlay = mappedOverlay.find(
            newOverlay => newOverlay._id === overlay._id
          );
          socket.emit(OVERLAY_ADD, { broadcastId });
          return updatedOverlay;
        }
      };

      dispatch(action);
    }
  );
}

export default updateOverlayUploadStatus;
